import { IUnitEventData } from '@src/core/Unit/models';
import { AnyType } from '@src/models/common';

export interface ICenLead {
  /** Наш Client Device Id из Unit-подсистемы */
  cen_id?: string;

  /** Google Analytics Client Device Id */
  ga_id?: string;

  /** Yandex Metrika Client Device Id */
  ym_id?: string;

  hit_id?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_medium?: string;
  utm_source?: string;
}

/**
 * IMPORTANT! Результат функции НЕЛЬЗЯ КЕШИРОВАТЬ!
 *
 * Данные могут меняються по ходу нахождения пользователя на странице.
 * Делать вызов нужно непосредственно перед отправкой результаттов куда-то на бекенд.
 *
 * Информация о лиде устанавлияется в window.CEN_LEAD
 * силами аналитиков в Google Tag Manager-е.
 * Мы просто долэны пробрасывать данные на бекенды
 * не сильно вдаваясь откуда данные и что в них.
 *
 * @example На выход получается что-то такое
 * {
 *   cen_id: "2057676388.1660824621"
 *   ga_id: "658385691.1648451885"
 *   hit_id: "1661333027818.ufnev0b9"
 *   utm_campaign: undefined
 *   utm_content: undefined
 *   utm_medium: undefined
 *   utm_source: undefined
 *   ym_id: "1638874950857758426"
 * }
 */
export const getCenLead = (): ICenLead => {
  if (typeof window === 'undefined') {
    return {};
  }

  return window['CEN_LEAD'] || {};
};

/**
 * Для того, чтобы аналитики смогли прослушивать все события юнитом через свою функцию в GT (Google Tag Manager)
 * без прослушивания DOM дерева.
 */
export const handleCenUnitHit = (record: IUnitEventData) => {
  if (typeof window === 'undefined') {
    return;
  }
  const hasHandlerFunction = window['CEN_UNIT_HIT_HANDLER'] || typeof window['CEN_UNIT_HIT_HANDLER'] === 'function';
  if (!hasHandlerFunction) {
    return;
  }
  try {
    window['CEN_UNIT_HIT_HANDLER'](record);
  } catch (e) {
    if (console.error) {
      console.error('Unexpected error in handle cen unit hit', e);
    }
  }
};

export const trackEvent = (event: AnyType, payload = {}) => {
  const data = {
    event,
    ...payload,
  };
  // @ts-ignore
  if (!!window['dataLayer']) {
    // @ts-ignore
    window['dataLayer'].push(data);
  }
};

/**
 * Данные в BigQuery записываются по гринвичу
 */
export const getUTCTimestamp = (): number => {
  const now = new Date();
  return Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
    now.getUTCMilliseconds(),
  );
};
